export default {
  boolean: { 0: '否', 1: '是' },
  boolean2: { 0: '是', 1: '否' },
  has: { 0: '无', 1: '有' },
  isHidden: { 0: '启用', 1: '禁用' },
  isDisable: { 0: '启用', 1: '禁用' },
  sex: { 0: '女', 1: '男' },
  subjectType: { 1: '自选', 2: '抽题' },
  screenStatus: { 2: '横屏' },
  status: { 0: '待填写', 1: '待发布', 2: '已发布', 3: '已关闭' },
  categoryLevel: { 1: '一级分类', 2: '二级专业', 3: '三级级别' },
  payStatus: { 0: '未支付', 1: '已支付', 2: '已退款' },
  isPayed: { 0: '待付款', 1: '已付款' },
  isImport: { 0: '线上', 1: '导入' },
  auditStatus: { 1: '待审核', 2: '审核通过', 3: '审核未通过' },
  chooseQuestionStep: { 0: '报名时', 1: '考试时' },
  questionType: { 1: '模拟', 2: '正式' },
  newsType: { 0: '图文' },
  newsModule: { 0: '协会动态', 1: '会员中心', 2: '赛事活动', 3: '考级咨询' },
  linkType: { 0: '文章', 1: '外链' },
  payType: { 0: '支付宝', 1: '微信' },
  tradeState: { 0: '待支付', 1: '未支付', 2: '已支付', 3: '已取消', 4: '申请退款', 5: '已退款', 6: '退款失败' },
  idType: { '1': '身份证', '2': '港澳通行证', '3': '护照', '4': '台胞证' },
  smsType: { 0: '注册', 1: '找回密码', 2: '登录', 3: '修改账号' },
  dimensionType: { 0: '科目评分', 1: '综合评分' },
  evaluateType: { 0: '自定义设置', 1: '分值设置' },
  evaluateStatus: { 0: '未设置', 1: '已设置', 2: '评分中', 3: '已评分', 4: '已发布' },
  evaluateStatus2: { 0: '未评分', 1: '评分中', 2: '已评分', 3: '已发布' },
  evaluateStatus3: { 0: '未打印', 2: '已打印' },
  isEvaluate: { 0: '未评审', 1: '已评审' },
  isPublish: { 0: '未发布', 1: '已发布' },
  examStatus: { 0: '未开始考试', 1: '未完成考试', 2: '考试中', 3: '已完成考试' },
  isOnline: { 0: '线下评分', 1: '线上评分' },
  countryCode: [{ code: "000000", desc: "国际" }, { code: "000001", desc: "中国大陆" }, { code: "999999", desc: "港澳台侨" }],
  isLine: { 0: '线上和线下', 1: '线下' },
  isRepeat: { 0: '否', 1: '是' },
  system: { 0: '体制内', 1: '新文艺群体' },
  state: { 0: '在职', 1: '离退休', 2: '出境/出国定居', 3: '失联', 4: '重疾', 5: '去世', 6: '退会', 7: '开除', 8: '空' },
  education: { 0: '博士研究生', 1: '硕士研究生', 2: '大学', 3: '大专', 4: '高中', 5: '无' },
  politics: { 0: '中共', 1: '民革', 2: '民盟', 3: '民建', 4: '民进', 5: '农工', 6: '致公', 7: '九三学社', 8: '台盟', 9: '无党派', 10: '群众' },
  nationality: { 0: '中国', 1: '国外' },
  professional: { 0: '创作', 1: '理论', 2: '表演', 3: '其他' },
  specialZhicheng: { 0: '正高', 1: '副高', 2: '中级', 3: '初级', 4: '无' }
}
